export default __webpack_public_path__ + "static/media/eigenheim_icons_calculator.13822564.svg";